import { Component, inject, input, OnInit } from '@angular/core';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { FileManagerService } from './file-manager.service';
import { FileManagerUploadComponent } from './file-manager-upload.component';
import { getMetadata, getStorage, listAll, ref } from '@angular/fire/storage';
import { StorageReference } from '@firebase/storage';

@Component({
  selector: 'ava-file-manager-list',
  standalone: true,
  template: `
    @if (fileList.length) {
      <ava-file-manager-upload [directory]="directory()" [fileList]="fileList" />
    }
  `,
  imports: [FileManagerUploadComponent],
})
export class FileManagerListComponent implements OnInit {
  fmService = inject(FileManagerService);

  directory = input('');
  fileList: NzUploadFile[] = [];

  ngOnInit(): void {
    this.getFileList();
  }

  private getFileList() {
    if (this.directory()) {
      //   const storageRef: FirebaseStorageRef = firebase.storage().ref();
      //   const listRef = storageRef.child(this.directory);
      //   listRef
      //     .listAll()
      //     .then((result) => {
      //       result.items.forEach((item) => {
      //         this.getWindowMetaData(item, storageRef);
      //         const file: NzUploadFile = {
      //           uid: '',
      //           name: item.name, // this.fmService.domain + "/" + this.directory + "/" + item.name,
      //           url: this.fmService.domain + '/' + item.fullPath,
      //           thumbUrl: this.fmService.domain + '/' + item.fullPath,
      //           status: 'done',
      //         };
      //         this.fileList.push(file);
      //       });
      //     })
      //     .catch(function (error) {
      //       console.log(error);
      //     });
      const storage = getStorage();
      const storageRef = ref(storage, this.directory());

      listAll(storageRef)
        .then((result) => {
          result.items.forEach((itemRef) => {
            this.getWindowMetaData(itemRef, storageRef);

            const file: NzUploadFile = {
              uid: itemRef.name,
              name: itemRef.name,
              url: `${this.fmService.domain}/${itemRef.fullPath}`,
              thumbUrl: `${this.fmService.domain}/${itemRef.fullPath}`,
              status: 'done',
            };

            this.fileList.push(file);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  getWindowMetaData(item: StorageReference, storageRef: StorageReference): void {
    // const fileRef = storageRef.child(item.fullPath);
    // fileRef
    //   .getMetadata()
    //   .then((metadata) => {
    //     this.fileList.forEach((file) => {
    //       if (file.name === item.name) {
    //         file.metadata = metadata;
    //         if (file.message === 'Upload error') {
    //           file.message = '';
    //         }
    //       }
    //     });
    //     // console.log(metadata)
    //     // Metadata now contains the metadata for 'images/forest.jpg'
    //   })
    //   .catch(() => {
    //     // Uh-oh, an error occurred!
    //   });
    // Todo: need to test
    // v9 way: build ref directly (no .child())
    const fileRef = ref(storageRef, item.fullPath);

    getMetadata(fileRef)
      .then((metadata) => {
        this.fileList.forEach((file) => {
          if (file.name === item.name) {
            file.metadata = metadata;

            if (file.message === 'Upload error') {
              file.message = '';
            }
          }
        });
        // metadata contains file details
      })
      .catch((error) => {
        console.log('Metadata fetch error:', error);
      });
  }
}
